export default {"src":"/_next/static/media/exceptional.d2b56488.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};